/* accordion
========================================================= */
export function accordion($) {
  const $triggers = $('dl.price__item dt');

  if (!$triggers.length) {
    return;
  }

  $triggers.on('click.accordion', function () {
    $(this).toggleClass('open').next('dd').stop(true, true).slideToggle();
  });
}
